/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbFormateurProfessionGridDto } from './FcbFormateurProfessionGridDto';
import {
    FcbFormateurProfessionGridDtoFromJSON,
    FcbFormateurProfessionGridDtoFromJSONTyped,
    FcbFormateurProfessionGridDtoToJSON,
} from './FcbFormateurProfessionGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbFormateurProfessionGridDtoPaginatedResults
 */
export interface FcbFormateurProfessionGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurProfessionGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbFormateurProfessionGridDto>}
     * @memberof FcbFormateurProfessionGridDtoPaginatedResults
     */
    results?: Array<FcbFormateurProfessionGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbFormateurProfessionGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbFormateurProfessionGridDtoPaginatedResults interface.
 */
export function instanceOfFcbFormateurProfessionGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbFormateurProfessionGridDtoPaginatedResultsFromJSON(json: any): FcbFormateurProfessionGridDtoPaginatedResults {
    return FcbFormateurProfessionGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbFormateurProfessionGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbFormateurProfessionGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbFormateurProfessionGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbFormateurProfessionGridDtoPaginatedResultsToJSON(value?: FcbFormateurProfessionGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbFormateurProfessionGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

